import { useDrawer } from 'src/hooks/useDrawer';
import { useState } from 'react';

import classNames from 'classnames';
import { isShowCatchGame } from '../../helpers';
import { CatchGameLink } from './components/CatchGameLink';
import { CloseIcon } from 'src/EXPERIMENTAL_LIB/modules/gpt/games/components/ModalWrapper/components/CloseIcon';

export const PopUpCatchGame = () => {
  const { isLeftDrawerOpen } = useDrawer();
  const [showBanner, setShowBanner] = useState(true);

  const handleBannerClose = () => {
    setShowBanner(false);
  };
  if (!isShowCatchGame()) return null;

  return (
    <>
      {showBanner && (
        <div
          className={classNames(
            'flex w-full justify-end m-auto pr-3 mb-5',
            isLeftDrawerOpen && 'blured'
          )}>
          <div className="w-[220px] 768:w-[250px] pointer-events-auto overflow-hidden relative cursor-pointer pt-[34px] pl-[21px] 768:pl-[54px] self-end">
            <button
              onClick={handleBannerClose}
              className="rounded-3xl p-1 absolute top-0 right-0 w-6 h-6 flex justify-center items-center">
              <CloseIcon />
            </button>
            <CatchGameLink />
          </div>
        </div>
      )}
    </>
  );
};
